import { putFeedback, fetchLocation } from '../api';
import * as types from './types';

export const openFeedback = () => {
	return {
		type: types.OPEN_FEEDBACK
	}
}

export const closeFeedback = () => {
	return {
		type: types.CLOSE_FEEDBACK
	}
}

export const setFeedbackLocation = (location) => {
	return {
		type: types.SET_FEEDBACK_LOCATION,
		location
	}
}

export const setFeedbackShard = (shard) => {
	return {
		type: types.SET_FEEDBACK_SHARD,
		shard
	}
}

export const clearFeedbackLocation = (location) => {
	return {
		type: types.CLEAR_FEEDBACK_LOCATION
	}
}

export const setFeedbackIsp = (isp) => {
	return {
		type: types.SET_FEEDBACK_ISP,
		isp
	}
}

export const setFeedbackIspOther = (isp_other) => {
	return {
		type: types.SET_FEEDBACK_ISP_OTHER,
		isp_other
	}
}

export const setFeedbackSubmitting = (submitting) => {
	return {
		type: types.SET_FEEDBACK_SUBMITTING,
		submitting
	}
}

export const setFeedbackData = (data) => {
	return {
		type: types.SET_FEEDBACK_DATA,
		data
	}
}

// TODO: should this just use the existing location actions?
export const fetchFeedbackLocation = (location_id, shard) => {
	return async (dispatch, getState) => {
		const data = await fetchLocation(location_id, shard);

		dispatch(setFeedbackLocation(data));
	}
}

//TODO should this take the booted shard app, or the one set during feedback input via setFeedbackShard?
export const submitFeedback = () => {
	return async (dispatch, getState) => {
		const { feedback: { data }, config: { shard } } = getState();

		dispatch(setFeedbackSubmitting(true));

		await putFeedback({shard, ...data});

		dispatch(setFeedbackSubmitting(false));
	}
}

export const setFeedbackStep = (step) => {
	return async (dispatch, getState) => {
		await dispatch(submitFeedback());

		dispatch({
			type: types.SET_FEEDBACK_STEP,
			step
		});
	}
}


// WEBPACK FOOTER //
// ./src/actions/feedback.js